export enum BillState {
  Approved = 'approved',
  Draft = 'draft',
  Voided = 'voided',
}
